module.exports = __webpack_public_path__ + "img/allegedly.7cc00014.png";